import { BellRinging, Checks } from "@phosphor-icons/react";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useStaffOrders } from "../../context/StaffOrdersContext";
import { StaffAuthScreen } from "./StaffAuthScreen";
import { StaffBottomNav } from "./StaffBottomNav";

export function StaffLayout() {
  const location = useLocation();
  const { isLoading, isAuthenticated } = useStaffOrders();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  if (isLoading) {
    return (
      <div className="staff-app-stage min-h-[100dvh] bg-[radial-gradient(circle_at_top_left,rgba(198,161,90,0.18),transparent_24%),radial-gradient(circle_at_bottom_right,rgba(31,118,120,0.16),transparent_26%),linear-gradient(180deg,#141b1b_0%,#0d1212_100%)] px-0 md:px-5 md:py-5">
        <div className="staff-app-frame relative mx-auto flex min-h-[100dvh] max-w-[430px] flex-col overflow-hidden bg-[#0f1718] text-stone-50 md:min-h-[calc(100dvh-2.5rem)] md:rounded-[2.8rem] md:border md:border-white/8 md:shadow-[0_36px_88px_-52px_rgba(0,0,0,0.88)]">
          <main className="flex flex-1 items-center justify-center px-6">
            <div className="space-y-4 text-center">
              <div className="mx-auto h-12 w-12 animate-spin rounded-full border-2 border-white/10 border-t-amber-200" />
              <p className="text-sm text-stone-300">Подключаем рабочую смену…</p>
            </div>
          </main>
        </div>
      </div>
    );
  }

  return (
    <div className="staff-app-stage min-h-[100dvh] bg-[radial-gradient(circle_at_top_left,rgba(198,161,90,0.18),transparent_24%),radial-gradient(circle_at_bottom_right,rgba(31,118,120,0.16),transparent_26%),linear-gradient(180deg,#141b1b_0%,#0d1212_100%)] px-0 md:px-5 md:py-5">
      <a
        href="#staff-content"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-full focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-stone-950"
      >
        Перейти к панели работников
      </a>

      <div className="staff-app-frame relative mx-auto flex min-h-[100dvh] max-w-[430px] flex-col overflow-hidden bg-[#0f1718] text-stone-50 md:min-h-[calc(100dvh-2.5rem)] md:rounded-[2.8rem] md:border md:border-white/8 md:shadow-[0_36px_88px_-52px_rgba(0,0,0,0.88)]">
        <div className="pointer-events-none absolute inset-x-0 top-0 h-36 bg-[radial-gradient(circle_at_top,rgba(198,161,90,0.2),transparent_60%)]" />
        <div className="pointer-events-none absolute left-1/2 top-4 h-1.5 w-20 -translate-x-1/2 rounded-full bg-white/10 md:top-5" />

        {isAuthenticated ? (
          <>
            <header className="relative flex items-center justify-between border-b border-white/8 px-4 pb-3 pt-8 md:pt-9">
              <div>
                <p className="text-[0.68rem] uppercase tracking-[0.24em] text-amber-200/72">Чайхана Изумруд</p>
                <p className="mt-1 text-sm font-medium tracking-tight text-stone-100">Панель работников</p>
              </div>

              <div className="flex items-center gap-2">
                <span className="inline-flex items-center gap-2 rounded-full border border-white/8 bg-white/6 px-3 py-1.5 text-[0.72rem] uppercase tracking-[0.18em] text-stone-200">
                  <Checks size={14} weight="fill" />
                  смена
                </span>
                <span className="grid h-9 w-9 place-items-center rounded-full border border-white/8 bg-white/6 text-stone-100">
                  <BellRinging size={17} />
                </span>
              </div>
            </header>

            <main id="staff-content" className="relative flex-1">
              <Outlet />
            </main>

            <StaffBottomNav />
          </>
        ) : (
          <StaffAuthScreen />
        )}
      </div>
    </div>
  );
}
